<div class="lua-separateur-groupe">
    <div>{{labelSeparateur}}</div>
    <lua-bouton-icone 
        *ngIf="iconName"
        [iconName]="iconName">
    </lua-bouton-icone>    
</div>
